module.exports = __webpack_public_path__ + "img/1.56c72412.png";